import styled from 'styled-components';
import { IonFooter } from '@ionic/react';

export const IonFooterWrapper = styled(IonFooter)`
  .ios {
    &.segment {
      margin-bottom: var(--ion-safe-area-bottom);
      border-radius: 0;
    }
  }
  .segment-light {
    --background: var(--ion-color-light);
  }
  .segment-dark {
    --background: var(--ion-color-light);
  }
  .dashboard-button {
    --color-checked: var(--ion-color-primary-contrast);
    --background-checked: var(--ion-color-primary);
    --indicator-color: var(--ion-color-primary-shade);
    --color: var(--ion-color-light-contrast);
  }
  .jobsearch-button {
    --color-checked: var(--ion-color-primary-contrast);
    --background-checked: var(--ion-color-primary);
    --indicator-color: var(--ion-color-primary-shade);
    --color: var(--ion-color-light-contrast);
  }
  .history-button {
    --color-checked: var(--ion-color-primary-contrast);
    --background-checked: var(--ion-color-primary);
    --indicator-color: var(--ion-color-primary-shade);
    --color: var(--ion-color-light-contrast);
  }
`;